import React from 'react';
import { Text } from '../../../globalStyles';
import * as Styles from '../styles';
import { FinalButton } from '../../../Components/FinalButton';

interface EnrollOptionProps {
  title: string;
  label: string;
  description?: string;
  testId?: string; // testId is for cypress testing
  onClick: () => void;
}

export function EnrollOption({ title, label, description, testId, onClick }: EnrollOptionProps) {
  return (
    <Styles.OptionContainer>
      <Styles.OptionContainerTitle>
        <Text.h2 className="ml2">{title}</Text.h2>
        <Text.label className="ml2 mt2">{label}</Text.label>
        {description && <Text.bodyGrey className="pt1 ml2 mt2">{description}</Text.bodyGrey>}
      </Styles.OptionContainerTitle>
      <Styles.ButtonContainer>
        <FinalButton size="normal" kind="outline_black" data-cy={testId} onClick={onClick}>
          Select
        </FinalButton>
      </Styles.ButtonContainer>
    </Styles.OptionContainer>
  );
}
